import { DateTime } from "luxon";

const formatdate = (date: DateTime | null | undefined) => {
  if (!date) {
    return "";
  }
  return date.toFormat("yyyy年MM月dd日");
};

export default formatdate;
